module.exports = __webpack_public_path__ + "img/sologan.03138ccb.svg";